export default {
  props: {

    icon: {
      type: String,
      default() {
        return "#the_third_icontijiao2"
      }
    },
    size: {
      type: String,
      default() {
        return null
      }
    },
    iconStyle: {
      type: Object,
      default() {
        if (this.size == "mini") {
          return {padding: '0px 2px'}
        } else if (this.size=="small"){
          return {padding: '6px 2px'}
        } else{
          return {padding: '4px 16px'}
        }

      }
    }
  },
  data() {
    return {}
  },
  methods: {
    nClick() {
      this.$emit("click")
    }
  }
}



// WEBPACK FOOTER //
// ./src/ni-ui/icon/icon.js